(function() {
  function initCategorySlider(root) {
    if (!root || root.dataset.categorySliderInitialized === 'true') return;

    var track = root.querySelector('[data-category-slider-track]') || root.querySelector('#vwoCatTrack');
    var outer = root.querySelector('[data-category-slider-outer]') || root.querySelector('#vwoCatTrackOuter');
    var prevBtn = root.querySelector('[data-category-slider-prev]') || root.querySelector('#vwoCatPrev');
    var nextBtn = root.querySelector('[data-category-slider-next]') || root.querySelector('#vwoCatNext');

    if (!track || !outer || !prevBtn || !nextBtn) return;

    root.dataset.categorySliderInitialized = 'true';

    var isPointerDown = false;
    var isDragging = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;
    var shouldBlockClick = false;
    var dragThreshold = 6;

    function getSlideWidth() {
      var slide = track.querySelector('.vwo-cat-slide');
      if (!slide) return outer.clientWidth * 0.8;

      var trackStyles = window.getComputedStyle(track);
      var gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0);

      return slide.offsetWidth + gap;
    }

    function getMaxScrollLeft() {
      return Math.max(0, outer.scrollWidth - outer.clientWidth);
    }

    function updateNavButtons() {
      var maxScrollLeft = getMaxScrollLeft();
      var currentScrollLeft = outer.scrollLeft;
      var buffer = 2;

      if (currentScrollLeft > buffer) {
        prevBtn.classList.add('visible');
      } else {
        prevBtn.classList.remove('visible');
      }

      if (currentScrollLeft >= maxScrollLeft - buffer) {
        nextBtn.style.opacity = '0.35';
        nextBtn.style.pointerEvents = 'none';
      } else {
        nextBtn.style.opacity = '1';
        nextBtn.style.pointerEvents = 'all';
      }
    }

    function scrollBySlide(direction) {
      outer.scrollTo({
        left: outer.scrollLeft + getSlideWidth() * direction,
        behavior: 'smooth'
      });
    }

    prevBtn.addEventListener('click', function() {
      scrollBySlide(-1);
    });

    nextBtn.addEventListener('click', function() {
      scrollBySlide(1);
    });

    outer.addEventListener('scroll', updateNavButtons, { passive: true });

    outer.addEventListener('dragstart', function(event) {
      event.preventDefault();
    });

    outer.addEventListener('pointerdown', function(event) {
      if (event.button !== undefined && event.button !== 0) return;

      isPointerDown = true;
      isDragging = false;
      shouldBlockClick = false;
      dragStartX = event.clientX;
      dragStartScrollLeft = outer.scrollLeft;
    });

    outer.addEventListener('pointermove', function(event) {
      if (!isPointerDown) return;

      var diff = event.clientX - dragStartX;

      if (!isDragging && Math.abs(diff) > dragThreshold) {
        isDragging = true;
        shouldBlockClick = true;
        outer.classList.add('dragging');
      }

      if (!isDragging) return;

      event.preventDefault();
      outer.scrollLeft = dragStartScrollLeft - diff;
    });

    function endDrag() {
      if (!isPointerDown) return;

      isPointerDown = false;
      isDragging = false;
      outer.classList.remove('dragging');
      updateNavButtons();
    }

    outer.addEventListener('pointerup', endDrag);
    outer.addEventListener('pointercancel', endDrag);
    outer.addEventListener('pointerleave', endDrag);

    outer.addEventListener('click', function(event) {
      if (shouldBlockClick) {
        event.preventDefault();
        event.stopPropagation();
        shouldBlockClick = false;
      }
    }, true);

    window.addEventListener('resize', updateNavButtons);

    updateNavButtons();
  }

  function initAllCategorySliders(container) {
    var scope = container || document;
    var sectionSliders = scope.querySelectorAll('[data-category-slider]');

    if (sectionSliders.length) {
      sectionSliders.forEach(function(slider) {
        initCategorySlider(slider);
      });
      return;
    }

    var legacyOuter = document.getElementById('vwoCatTrackOuter');
    if (legacyOuter) {
      initCategorySlider(document);
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAllCategorySliders(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initAllCategorySliders(event.target);
  });

  document.addEventListener('shopify:block:select', function(event) {
    if (!event.detail || !event.detail.blockId) return;

    var selectedBlock = document.querySelector('[data-block-id="' + event.detail.blockId + '"]');
    if (!selectedBlock) return;

    var outer = selectedBlock.closest('[data-category-slider-outer], #vwoCatTrackOuter');
    if (!outer) return;

    outer.scrollTo({
      left: selectedBlock.offsetLeft - outer.offsetLeft,
      behavior: 'smooth'
    });
  });
})();
